import type React from 'react';

import type { WorkflowStep } from '../../types';
import { FinishStepContent } from './finish-step-content';
import styles from './styles.module.less';

type FinishStepCardProps = {
  step: WorkflowStep;
};

export const FinishStepCard: React.FC<FinishStepCardProps> = ({ step }) => (
  <div className={styles.card}>
    <FinishStepContent step={step} />
  </div>
);
